const SUPPORTS_SCROLL_TIMELINE = typeof CSS !== "undefined" && CSS.supports("animation-timeline: scroll()");
function initFullscreenPeek() {
  const root = document.documentElement;
  if (SUPPORTS_SCROLL_TIMELINE || root.hasAttribute("data-fullscreen-peek")) return;
  let peek = 0;
  let frame = 0;
  let state = null;
  let lastScroll = null;
  const readPeek = () => parseFloat(getComputedStyle(document.body).getPropertyValue("--sc-fullscreen-peek"));
  const measure = () => {
    peek = Math.max(readPeek() || 0, 0);
  };
  const write = () => {
    frame = 0;
    const scroll = Math.min(Math.max(window.scrollY, 0), peek);
    const next = scroll < peek ? "active" : "done";
    if (next !== state) {
      state = next;
      root.setAttribute("data-fullscreen-peek", next);
    }
    if (next === "active" && scroll !== lastScroll) {
      lastScroll = scroll;
      root.style.setProperty("--sc-fullscreen-scroll", `${scroll}px`);
    }
  };
  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(write);
  };
  if (Number.isNaN(readPeek())) return;
  measure();
  write();
  window.addEventListener("scroll", schedule, { passive: true });
  window.addEventListener(
    "resize",
    () => {
      measure();
      lastScroll = null;
      schedule();
    },
    { passive: true }
  );
}
initFullscreenPeek();
